import { render } from "./payment-select-window.vue?vue&type=template&id=7804e375&ts=true&lang=pug"
import script from "./payment-select-window.vue?vue&type=script&lang=ts&setup=true"
export * from "./payment-select-window.vue?vue&type=script&lang=ts&setup=true"

import "./payment-select-window.vue?vue&type=style&index=0&id=7804e375&lang=scss"

import exportComponent from "/Users/jonathanoaklyn/dev/consulting/opt/opt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__